import React, {useEffect, useState} from 'react';
import {FormPageRoot, ThemedButton, ThemedDialog, ThemedInput} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {checkNullStr, getDefStr, getJsonValue, isBoolTrue, isJsonValueTrue, vhToPx} from "../../../../common/fusion-ui/utils/ReactUtils";
import {focusFormIdElement, getAllocatedModuleName, getUserSessionField, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {EVENT_INPUT_MAX_LEN, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls,} from "../../../config/AppConfig";
import {Flexbox, Image, Label, MsgBox} from "../../../../common/fusion-ui";
import {CssVariant, Messages} from "../../../../common/fusion-ui/config/FusionConfig";
import {useInternetStatus} from "../../../../common/fusion-ui/hook";
import {UnderMaintenance, UnderMaintenanceMsg} from "../../../../common/CommonConfig";

const Peer_Recom_FormPage = React.memo(({asPanel = false, redirectUrl}) => {
    const TAG = "Peer_Recom_FormPage";

    const moduleName = Modules.RecommendPeer;
    const FormFields = ModuleFieldsData[moduleName];

    const mf_pp = Modules.PeerProfiles;

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();

    const FOCUS_DELAY = 2000;

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        isPdfFileLoading: 'isPdfFileLoading',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        showSuccessDialog: 'showSuccessDialog',
        successDialogOnHide: 'successDialogOnHide',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(Peer_Recom_FormPage_Data);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});

    useEffect(() => {
        // setFormData({});
        if (!checkNullStr(getField(Fields.isDataFound))) {
            updateField(Fields.isDataFound, true);
            updateField(Fields.isDataLoading, false);
        }
    }, []);

    return (<>
        {isBoolTrue(asPanel) ? createForm() : createFormPage()}
        {createSuccessDialog()}
    </>)

    function createFormPage() {
        return <FormPageRoot
            tag={TAG}
            moduleName={mf_pp}
            addPageTitle={getTabTitle()}
            isDataLoading={getField(Fields.isDataLoading)}
            isDataFound={getField(Fields.isDataFound)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            md={6}>
            {createForm()}
        </FormPageRoot>
    }

    function createForm() {
        return <div>
            <div>
                {/*name*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.name.title}
                    placeholder={FormFields.name.title}
                    id={FormFields.name.column}
                    type={'text'}
                    value={getFormField(FormFields.name)}
                    msg={getFormFieldMsg(FormFields.name)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.name, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.name, '');
                    }}
                />

                {/*phone*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.phone.title}
                    placeholder={FormFields.phone.title}
                    id={FormFields.phone.column}
                    type={'mobile'}
                    value={getFormField(FormFields.phone)}
                    msg={getFormFieldMsg(FormFields.phone)}
                    showLimitLabel={true}
                    maxLength={14}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        if ((value + '').length <= 14) {
                            let sanitizedInput = (value + '')
                                .replace(/[^0-9\s\-+ ]/g, '')
                                .replaceAll("++", "+").replaceAll("--", "-")
                                .replaceAll("-+", "-").replaceAll("+-", "+")
                                .replaceAll("  ", " ");
                            updateFormField(FormFields.phone, sanitizedInput);
                            if (checkNullStr(value)) updateFormFieldMsg(FormFields.phone, '');
                        }
                    }}
                />

                {/*email*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.email.title}
                    placeholder={FormFields.email.title}
                    id={FormFields.email.column}
                    type={'email'}
                    value={getFormField(FormFields.email)}
                    msg={getFormFieldMsg(FormFields.email)}
                    showLimitLabel={true}
                    maxLength={100}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 100) {
                            if (checkNullStr(value)) {
                                let valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                                updateFormField(FormFields.email, value);
                                if (checkNullStr(value)) updateFormFieldMsg(FormFields.email, valid ? '' : 'Invalid email!');
                            }
                        }
                        // updateFormField(FormFields.email, value);
                        // if (checkNullStr(value)) updateFormFieldMsg(FormFields.email, '');
                    }}
                />

                {/*city*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.city.title}
                    placeholder={FormFields.city.title}
                    id={FormFields.city.column}
                    type={'text'}
                    value={getFormField(FormFields.city)}
                    msg={getFormFieldMsg(FormFields.city)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    required={true}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.city, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.city, '');
                    }}
                />

                {/*comment*/}
                <ThemedInput
                    wrapperClassName={''}
                    className={''}
                    label={FormFields.comment.title}
                    placeholder={FormFields.comment.title}
                    id={FormFields.comment.column}
                    type={'text'}
                    value={getFormField(FormFields.comment)}
                    msg={getFormFieldMsg(FormFields.comment)}
                    showLimitLabel={true}
                    maxLength={EVENT_INPUT_MAX_LEN}
                    asTextArea={true}
                    style={{
                        minHeight: '50px',
                        height: '80px',
                        maxHeight: '200px'
                    }}
                    onChange={(e) => {
                        const value = e.target.value;
                        updateFormField(FormFields.comment, value);
                        if (checkNullStr(value)) updateFormFieldMsg(FormFields.comment, '');
                    }}
                />
            </div>

            {/*by*/}
            <ThemedInput
                label={"Recommended by"}
                placeholder={"Recommended by"}
                value={getUserSessionField('fullName')}
                readOnly={true}
            />

            {/*footer*/}
            <div className={'mt-3'}>
                {/*msg-box*/}
                {checkNullStr(getField(Fields.panelMsg)) && <MsgBox color={getField(Fields.panelMsgColor, theme.text)}>
                    {getField(Fields.panelMsg)}
                </MsgBox>}

                {/*controls*/}
                <Flexbox className={'mt-2'} justifyAt={'center'} alignAt={'center'}>
                    <ThemedButton
                        className={'rounded-2 w-auto px-4 py-1'}
                        text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Uploading...' : 'Upload'}
                        variant={theme.primaryBlue}
                        hoverBgColor={theme.primaryBlueDark}
                        loadingWidth={'auto'}
                        asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                        disabled={isFieldTrue(Fields.submitBtn_disabled)}
                        onClick={handleSubmit}
                    />
                </Flexbox>
            </div>
        </div>
    }

    function createSuccessDialog() {
        return <ThemedDialog
            className={"rounded-6 p-0 m-0"}
            titleClassName={'fs-lg mb-2'}
            open={isFieldTrue(Fields.showSuccessDialog)}
            title={"Thanks"}
            showClose={true}
            showFooter={false}
            closeOnEscape={true}
            closeOnOutsideClick={true}
            onHide={() => {
                const onHide = getField(Fields.successDialogOnHide);
                if (onHide) onHide();
                // updateField(Fields.showSuccessDialog, false);
            }}
        >
            <div className={'px-3'}>
                <div className={'m-0 p-0 pt-1 px-2 d-none-smx h-100 auth-img-wrapper w-100'}>
                    <Image
                        wrapperClassName={`w-100 rounded-6 overflow-hidden select-none`}
                        className={`auth-ra-img transition-sm`}
                        src={"https://cdn.pixabay.com/photo/2016/11/07/00/49/thanks-1804597_1280.jpg"}
                        // src={"https://cdn.pixabay.com/photo/2020/04/22/11/59/thank-you-5077738_1280.jpg"}
                        width={'100%'}
                        height={vhToPx('60vh') + 'px'}
                        objectFit={'cover'}
                        disableDrag={true}
                    />
                </div>

                <div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-semi-bold mt-3 fs-normal'} color={theme.text80} textAt={'center'}>
                            {getDefStr(getField(Fields.panelMsg), Messages.formDataSaveSuccess)}
                        </Label>
                    </div>
                    <div className={'w-100 d-flex jc-center'}>
                        <Label className={'text-wrap fw-bold fs-xl'} color={theme.primaryBlue} textAt={'center'}>
                            {"Many thanks for your kind recommendation."}
                        </Label>
                    </div>
                </div>
            </div>
        </ThemedDialog>
    }

    //======================Request Functions start=====================
    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    formData: formData,
                };
                sendRequest({
                    reqUrl: ReqUrls.peer__recomForm_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);

                            updateField(Fields.successDialogOnHide, (() => {
                                updateField(Fields.showSuccessDialog, false);
                                if (redirectUrl != -1) window.location.href = getDefStr(redirectUrl, ModuleRouteUrls[moduleName]);
                            }));
                            updateField(Fields.showSuccessDialog, true);
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = [
            FormFields.name,
            FormFields.phone,
            FormFields.email,
            FormFields.city,
        ];

        let verified = false;
        let colField = {};
        for (const field of requiredFields) {
            if (field.column === FormFields.email.column) {
                const value = getFormField(field);
                let valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                if (!valid) {
                    focusIdField(field.column);
                    toast(`Invalid email!`, CssVariant.danger);
                    updateFormFieldMsg(FormFields.email, 'Invalid email!');
                    return false;
                }
            } else if (!checkNullStr(formData[field.column])) {
                colField = field;
                verified = false;
                break;
            } else {
                verified = true;
            }
        }
        if (!verified) {
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colField.title}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    // function getTabTitle() {
    //     const indexOfSecondS = moduleName.indexOf('s', moduleName.indexOf('s') + 1); // Find index of second 's'
    //     return `Recommend ${moduleName.slice(0, indexOfSecondS) + moduleName.slice(indexOfSecondS + 1)}`;
    // }

    function getTabTitle() {
        // const withoutS = moduleName.replace('s', '');
        return getAllocatedModuleName(moduleName);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Peer_Recom_FormPage;
